import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OAuth2ClientData } from "@smartx/mikro-vt-client-api"
import type { RootState } from "../store"

interface ProfilesState {
  profiles: Array<OAuth2ClientData>
}

const initialState: ProfilesState = {
  profiles: [],
}

export const profilesSlice = createSlice({
  name: "profiles",
  initialState,
  reducers: {
    setProfiles: (state, action: PayloadAction<OAuth2ClientData[]>) => {
      state.profiles = action.payload
    },
  },
})

export const { setProfiles } = profilesSlice.actions
export const selectProfiles = (state: RootState) => state.profiles.profiles
export default profilesSlice.reducer
